import * as React from 'react'
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Tooltip,
  IconButton,
} from '@material-ui/core'
import { TransitionProps } from '@material-ui/core/transitions'
import { ArrowForwardSharp, ErrorRounded } from '@material-ui/icons'

import { useFlow } from 'contexts/Flow/flowContext'
import useTranslator from 'utils/hooks/Translator'
import { useStyles } from './styles'

export interface Problem {
  type: 'error' | 'warning'
  groupId: string
  blockId: number
  blockName: string
  message: string
}

export function LinterErrorsGroupsModal() {
  const classes = useStyles()
  const { dispatch, groupsProblems, loadFlow, state } = useFlow()
  const { getTranslation } = useTranslator()

  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />
  })

  // TODO: Groups block errors preview (Collapse)

  // const [expandedGroup, setExpandedGroup] = React.useState<string>()

  /* const handleToggleGroup = (groupId: string) => {
    setExpandedGroup((prev) => (prev === groupId ? undefined : groupId))
  } */

  const handleClose = () => {
    dispatch({ type: 'closeGroupsLinterErrorModal' })
  }

  const groupedProblems = groupsProblems.reduce(
    (acc, problem) => {
      if (!acc[problem.groupId]) {
        acc[problem.groupId] = []
      }

      acc[problem.groupId].push(problem)

      return acc
    },
    {} as Record<string, Problem[]>,
  )

  const handleGoToGroup = async (groupId: string) => {
    if (!state.botName) return

    handleClose()

    await loadFlow(groupId, state.botName)

    dispatch({
      type: 'setIdGroup',
      data: { idGroup: groupId },
    })
  }

  return (
    <Dialog
      open
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: classes.paper }}
      aria-labelledby="groups-errors-title"
    >
      <DialogTitle
        id="groups-errors-title"
        disableTypography
        className={classes.titleRoot}
      >
        <Typography variant="h5">
          {getTranslation('linter.errors.modal.groups.title')}
        </Typography>
        <Typography variant="body2">
          {getTranslation('linter.errors.modal.groups.description')}
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.content}>
        {Object.entries(groupedProblems).map(([groupId, problems]) => {
          /* const isExpanded = expandedGroup === groupId */

          return (
            <React.Fragment key={groupId}>
              <div className={classes.groupHeader}>
                <div className={classes.groupHeaderTitle}>
                  <ErrorRounded className={classes.groupHeaderIconError} />

                  <Typography className={classes.groupName}>
                    {groupId}
                  </Typography>
                </div>

                <Tooltip
                  title={getTranslation(
                    'linter.errors.modal.groups.goToGroup',
                    { groupId },
                  )}
                >
                  <IconButton
                    size="medium"
                    onClick={() => handleGoToGroup(groupId)}
                  >
                    <ArrowForwardSharp fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>

              {/* <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <List dense className={classes.list}>
                  {problems.slice(0, 3).map((problem, index) => (
                    <ListItem
                      key={problem.blockId}
                      className={classes.listItem}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? grey[50] : 'transparent',
                      }}
                    >
                      <ListItemIcon
                        className={
                          problem.type === 'warning'
                            ? classes.listItemWarningIcon
                            : classes.listItemErrorIcon
                        }
                      >
                        {problem.type === 'warning' ? (
                          <WarningRounded />
                        ) : (
                          <ErrorRounded />
                        )}
                      </ListItemIcon>

                      <ListItemText
                        primary={problem.blockName}
                        secondary={problem.message}
                        secondaryTypographyProps={{
                          className: classes.secondaryText,
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse> */}
            </React.Fragment>
          )
        })}
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button onClick={handleClose} variant="outlined">
          {getTranslation('close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
